import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import { Select, SelectMultiple, } from '@tencent/tea-component/lib/select';
import classNames from 'classnames';
import isEqual from 'lodash.isequal';
import { Tag, TagGroup } from '@tencent/tea-component/lib/tag';
function useCampare(value, compare) {
    var ref = useRef(null);
    if (!compare(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
export function BuySelect(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Select, __assign({}, props, { className: classNames('buy-item-select', props.className), boxClassName: classNames('buy-select-radio__box', props.boxClassName), type: "simulate", appearance: "button" })));
}
export function CheckboxItem(_a) {
    var title = _a.title, description = _a.description;
    return (React.createElement("div", { className: "buy-select-label__checkbox" },
        React.createElement("p", { className: "buy-check-id" }, title),
        React.createElement("p", { className: "port" }, description)));
}
export function BuySelectMultiple(_a) {
    var value = _a.value, onChange = _a.onChange, text = _a.text, props = __rest(_a, ["value", "onChange", "text"]);
    var tagList;
    var options = props.options, valueUseUserSelectOrder = props.valueUseUserSelectOrder;
    if (options) {
        tagList = options.map(function (item) { return ({ id: item.value, text: item.tag }); });
    }
    var _b = __read(useState(value), 2), values = _b[0], setValues = _b[1];
    var _c = __read(useState([]), 2), tags = _c[0], setTags = _c[1];
    var handleSelectChange = function (tagIds, ctx) {
        var selectedTags = [];
        var selectedValues = [];
        if (valueUseUserSelectOrder) {
            tagIds.forEach(function (tagId) {
                var finder = tagList.find(function (tag) { return tagId === tag.id; });
                if (finder) {
                    selectedTags.push(finder);
                }
                var optionfinder = options.find(function (item) { return tagId === item.value; });
                if (optionfinder) {
                    selectedValues.push(optionfinder.value);
                }
            });
        }
        else {
            selectedTags = tagList.filter(function (tag) { return tagIds.includes(tag.id); });
            selectedValues = options.filter(function (item) { return tagIds.includes(item.value); }).map(function (item) { return item.value; });
        }
        setTags(selectedTags);
        setValues(selectedValues);
        if (ctx && onChange) {
            onChange(selectedValues, ctx);
        }
    };
    var handleTagClosed = function (id, e) {
        var newTags = tags.filter(function (tag) { return tag.id !== id; });
        var newValues = (values === null || values === void 0 ? void 0 : values.filter(function (item) { return item !== id; })) || [];
        setTags(newTags);
        setValues(newValues);
        if (values && onChange) {
            onChange(newValues, e);
        }
    };
    useEffect(function () {
        if (value) {
            handleSelectChange(value);
        }
    }, [useCampare(value, isEqual), useCampare(options, isEqual)]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectMultiple, __assign({}, props, { className: "buy-select-checkbox__multi", boxClassName: "buy-dropdown__box buy-select-checkbox__box", boxStyle: { minWidth: '300px', maxWidth: '300px' }, value: values, appearance: "button", onChange: function (val, ctx) { return handleSelectChange(val, ctx); } })),
        text,
        React.createElement(TagGroup, null, tags.map(function (_a) {
            var text = _a.text, id = _a.id;
            return (React.createElement(Tag, { className: "buy-tea-tag", onClose: function (e) { return handleTagClosed(id, e); }, key: id }, text));
        }))));
}
BuySelectMultiple.CheckboxItem = CheckboxItem;
//# sourceMappingURL=BuySelect.js.map